module.exports = "../../app/cells/components/weekly_errors_notebook_card_cell.rb";